import React from 'react';
import { useDroppable } from '@dnd-kit/core';

interface DroppableCalendarDayProps {
  id: string; // calendar-day-YYYY-MM-DD
  children: React.ReactNode;
  className?: string;
}

const DroppableCalendarDay: React.FC<DroppableCalendarDayProps> = ({
  id,
  children,
  className = '',
}) => {
  const { setNodeRef } = useDroppable({
    id,
    data: {
      type: 'calendarDay',
      dateStr: id.replace('calendar-day-', ''),
    },
  });

  return (
    <div ref={setNodeRef} className={className}>
      {children}
    </div>
  );
};

export default DroppableCalendarDay;
